export default __webpack_public_path__ + "static/media/HeroImage2.da22cf85.png";